import { FadeUp } from "./Reveal";

const MARQUEE_ITEMS = [
  "25+ Years Experience",
  "Delhi NCR Coverage",
  "Same-Day Service",
  "100% Solution Guaranteed*",
  "Free Inspection",
];

const STATS = [
  { value: "25+", label: "Years Experience" },
  { value: "Delhi NCR", label: "Service Coverage" },
  { value: "Same Day", label: "Inspection Available" },
  { value: "100%", label: "Solution Guaranteed*" },
];

export const TrustStrip = () => (
  <section data-testid="trust-strip" aria-label="Trust highlights">
    <div className="bg-wine text-ivory overflow-hidden py-4 grain">
      <div className="flex w-max animate-marquee-slow">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex shrink-0 items-center" aria-hidden={dup === 1}>
            {MARQUEE_ITEMS.concat(MARQUEE_ITEMS).map((item, i) => (
              <span key={`${dup}-${i}`} className="flex items-center">
                <span className="font-display italic text-lg lg:text-xl px-8 whitespace-nowrap">{item}</span>
                <span className="text-gold text-xs">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
    <div className="border-b border-border bg-ivory">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 grid grid-cols-2 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <FadeUp key={s.label} delay={i * 0.08} className={`py-8 lg:py-10 px-2 lg:px-8 ${i > 0 ? "border-l border-border" : ""} ${i === 2 ? "max-lg:border-l-0 max-lg:border-t" : ""} ${i === 3 ? "max-lg:border-t" : ""}`}>
            <p data-testid={`stat-value-${i}`} className="font-display text-3xl lg:text-4xl font-semibold text-wine">{s.value}</p>
            <p className="text-[11px] tracking-[0.2em] uppercase font-bold text-stone2 mt-1">{s.label}</p>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
